import styled from 'styled-components';
import Navbar from './Navbar';

export default styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;

	> ${Navbar} {
		flex-shrink: 0;
	}

	> .page {
		overflow: auto;
		flex-grow: 1;
	}
`;
